import template from './contactAssetsList.template.html';

export default {
  template,
  bindings: {
    assets: '<',
    contact: '<',
    lenders: '<',
    documents: '<',
    isOtherAssets: '<',
    onEdit: '&',
    onDelete: '&',
    onReady: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, listServiceNew, helperService, AssetType) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = function () {
        ctrl.list.setData(ctrl.assets);
        ctrl.onReady({ list: ctrl.list });
        ctrl.assets = ctrl.assets || [];
        ctrl.contact = ctrl.contact || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.isOtherAssets = ctrl.isOtherAssets || false;
      };

      ctrl.assetEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.assetDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.getCurrentIcon = (asset) => {
        let icon = 'local_atm';
        if (
          asset.assetType.id === AssetType.available()[0].id ||
          asset.assetType.id === AssetType.available()[1].id
        ) {
          icon = 'domain';
        }
        if (asset.assetType.id === AssetType.available()[2].id) {
          icon = 'directions_car';
        }
        return icon;
      };

      ctrl.assetTypeGetName = (assetType) => {
        const name = assetType.title;
        return name.replace(' address', '');
      };

      ctrl.getLenderDocument = (abbr) => {
        let doc;
        if (ctrl.documents.length) {
          doc = ctrl.documents.find(
            (d) => d.lender[0].abbr.toLowerCase() === abbr && d.type.indexOf('LOGO') > -1
          );
        }
        return doc ? doc.url : '';
      };

      ctrl.getAssetName = (asset) => {
        if (helperService.isAssetTypeBankAccount(asset.assetType)) {
          return ctrl.lenders.find((d) => d.abbr.toLowerCase() === asset.name)?.name || 'N/A';
        }
        return asset.getName();
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = (changes) => {
        if (changes.assets) {
          ctrl.initialize();
        }
      };
    }
  }
};
